<template>
  <AppFormItem label="Cliente">
    <AutocompleteApi
      :search="fetchCustomers"
      :value="customer || { id: null, name: 'Nenhum' }"
      :valueId="customerId"
      :disabled="disabled"
      :idField="'accountId'"
      @update:value="$emit('update:customer', $event)"
      @update:valueId="$emit('update:customerId', $event)"
    ></AutocompleteApi>
  </AppFormItem>
</template>

<script>
import AutocompleteApi from './AutocompleteApi.vue';
import { VetCustomerApi } from '../services/api';

export default {
  name: 'VetCustomerAutocomplete',
  components: {
    AutocompleteApi,
  },
  props: {
    customer: Object,
    customerId: Number,
    disabled: Boolean,
  },
  methods: {
    fetchCustomers: async () => {
      const response = await VetCustomerApi.fetch({
        order: 'asc',
        accepted: true,
      });
      response.results = response.results.map((result) => ({
        ...result,
        name: result.account.name,
      }));
      response.results.unshift({ id: null, name: 'Nenhum' });
      return response;
    },
  },
};
</script>

<style>
</style>
